export default "__VITE_ASSET__mcOQ96BK__"